import { useMemo } from 'react';
import { matchesKeyForVtp } from '../rethink/utils';
export const useVehiclePictures = ({ images, fallbackImage }) => {
    return useMemo(() => {
        if (!(images === null || images === void 0 ? void 0 : images.length)) {
            return fallbackImage ? [fallbackImage] : [];
        }
        const hasFallback = images.some((img) => { var _a; return (_a = img.type) === null || _a === void 0 ? void 0 : _a.includes('fallback'); });
        const hasVtp4x3m1c = images.some((img) => { var _a; return (_a = img.key) === null || _a === void 0 ? void 0 : _a.startsWith('vtp4x3m1c'); });
        const result = [];
        if (hasFallback) {
            const groups = {};
            images.forEach((img) => {
                var _a;
                const key = (_a = img.key) === null || _a === void 0 ? void 0 : _a.split('_')[1];
                if (!key)
                    return;
                groups[key] = groups[key] || [];
                groups[key].push(img);
            });
            if (groups['4x3']) {
                result.push(groups['4x3'][0]);
            }
            return result;
        }
        images.forEach((img) => {
            var _a, _b;
            if (((_a = img.type) === null || _a === void 0 ? void 0 : _a.startsWith('render')) && matchesKeyForVtp(img.key, hasVtp4x3m1c)) {
                result.push(img);
            }
            else if ((_b = img.type) === null || _b === void 0 ? void 0 : _b.startsWith('photo')) {
                result.push(img);
            }
        });
        if (result.length)
            return result;
        return fallbackImage ? [fallbackImage] : [];
    }, [images, fallbackImage]);
};
